import { X } from 'lucide-react';

interface FiltersBarProps {
  activeFiltersCount: number;
  resultsCount: number;
  currentPage: number;
  totalPages: number;
  onClearFilters: () => void;
}

export function FiltersBar({
  activeFiltersCount,
  resultsCount,
  currentPage,
  totalPages,
  onClearFilters,
}: FiltersBarProps) {
  return (
    <div className="flex items-center gap-3">
      {activeFiltersCount > 0 && (
        <button
          onClick={onClearFilters}
          className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all text-white hover:bg-white/10 border border-white/30 flex items-center gap-2"
        >
          <X className="w-3 h-3" />
          Clear Filters
        </button>
      )}
      <span className="text-xs text-[#9595a5] ml-auto">
        {resultsCount} {resultsCount === 1 ? 'character' : 'characters'} • Page {currentPage} of {totalPages}
      </span>
    </div>
  );
}
